import React from 'react';
import { Link } from 'react-router-dom';
import Galeria from '../components/Galeria';
import './Home.css';

function Home() {
    return (
        <div className="home">
            <title>DanPauleX | Operador de transportes</title>
            <link rel="canonical" href="https://danpaulex.com/" />
            <meta
                name="description"
                content="Danpaulex (DPX / TransDanPaulex) - Operador logístico y de transportes en Barcelona y a nivel nacional. Flota moderna, segura y eficiente para logística, distribución y carga."
            />

            {/* INTRO: TEXTO A LA IZQUIERDA + GALERÍA A LA DERECHA */}
            <section className="intro-galeria">
                <div className="intro-texto">
                    <h1>Soluciones logísticas a medida para industrias, eventos y cargas especiales</h1>
                    <p>
                        En DanPaulex ofrecemos transporte eficiente, seguro y especializado, con vehículos adaptados a cada necesidad.
                    </p>
                    <Link to="/servicios" className="boton-servicios">Nuestros servicios</Link>
                </div>
                <div className="home-galeria">
                    <Galeria />
                </div>
            </section>

            {/* SECCIÓN: TÍTULO + SUBTÍTULO + IMAGEN */}
            <section className="seccion-camiones">
                <h2>Nuestros vehículos listos para cada envío</h2>
                <p className="subtitulo-camiones">
                    Nuestros vehículos de transporte permiten transportar mercancías de forma rápida y segura,
                    minimizando los costes operativos y maximizando la eficiencia.
                </p>
                <img
                    src="/images/Camiones.PNG"
                    alt="Nuestra flota: camión de 7000 kg de carga útil, camión de 5000 kg, camión de 3000 kg, furgón carrozado con plataforma y furgoneta"
                    className="imagen-camiones"
                    width="1015"
                    height="178"
                    loading="lazy"
                    decoding="async"
                />
                <Link to="/contacto" className="boton-contacto">Pide un presupuesto</Link>
            </section>

        </div>
    );
}

export default Home;
